import { render, staticRenderFns } from "./OverViewYourPlan.vue?vue&type=template&id=fbf4e908&"
import script from "./OverViewYourPlan.vue?vue&type=script&lang=js&"
export * from "./OverViewYourPlan.vue?vue&type=script&lang=js&"
import style0 from "./OverViewYourPlan.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports